import * as React from 'react';
import { SVGProps } from 'react';

const SvgDangerOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      d="M11.679 13.791a.99.99 0 0 1-.986-.903l-.541-6.16a1.589 1.589 0 1 1 3.162.028l-.651 6.15a.99.99 0 0 1-.984.885Zm-1.56 3.688c0-.84.681-1.522 1.521-1.522h.045a1.521 1.521 0 1 1 0 3.043h-.045c-.84 0-1.521-.681-1.521-1.521Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgDangerOutlined;
